import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SitagLogo from '../../../../inc/assets/images/logo/sitag-logo.png';
import { handleChangeInputUserAuthenticationgPage } from '../../../../redux/actions/pages/trans/userAuthentication';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, CHECK_INSTALLMENTS_CODE } from '../../../../apis';
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import * as qs from "querystring";
import AjaxLoader from '../../../../inc/assets/images/Ajax-loader.gif';
import { Row, Col } from 'react-bootstrap';
import Collapse from '@mui/material/Collapse';

const UserAuthentication = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { barcode, mobile, barcodeBtnDisable, 
                fullname, nationalCode, normalCredit, normalCreditNumeric, orgCredit, orgCreditNumeric, orgTxt } = useSelector(state => state.userAuthentication);




    const [barcodeCollapsed, setBarcodeCollapsed] = React.useState(false);
    const handleBarcodeCollapsed = () => {
        setBarcodeCollapsed((prev) => !prev);
    };


    const [addFromCollapsed, setAddFormCollapsed] = React.useState(false);
    const handleAddFormCollapsed = () => {
        setAddFormCollapsed((prev) => !prev);
    };

    const [isVisibleAddForm, setIsVisibleAddForm] = useState(false);



    const showVerifyBoxHideAddForm = () => {
        setBarcodeCollapsed(true);

        setIsVisibleAddForm(false);
        setAddFormCollapsed(false);
    }



    useEffect(() => {
        setBarcodeCollapsed(true);
        // eslint-disable-next-line
    }, [UserAuthentication]);

    const handleNormalInput = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputUserAuthenticationgPage(name, value));
    };

    const handleSubmitFormBarcode = () => {
        if(! barcodeBtnDisable) {
            if(barcode.length === 4) {
                dispatch(handleChangeInputUserAuthenticationgPage('barcodeBtnDisable', true));


                axios({
                    method: 'post',
                    url: BASE_SITE + CHECK_INSTALLMENTS_CODE,
                    data: qs.stringify({
                        code: barcode,
                    }), headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded', 
                        'Authorization': token,
                    },
                }).then((response) => {
                    switch (response.data.status) {
                        case 'error':
                            dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                            break;
                        case 'ok':

                            dispatch(handleChangeInputUserAuthenticationgPage('barcode', ''));

                            dispatch(handleChangeInputUserAuthenticationgPage('fullname', response.data.fullname));
                            dispatch(handleChangeInputUserAuthenticationgPage('nationalCode', response.data.national_code));
                            dispatch(handleChangeInputUserAuthenticationgPage('normalCredit', response.data.normal_credit));
                            dispatch(handleChangeInputUserAuthenticationgPage('normalCreditNumeric', response.data.normal_credit_numeric));
                            dispatch(handleChangeInputUserAuthenticationgPage('orgCredit', response.data.org_credit));
                            dispatch(handleChangeInputUserAuthenticationgPage('orgCreditNumeric', response.data.org_credit_numeric));
                            dispatch(handleChangeInputUserAuthenticationgPage('orgTxt', response.data.org_txt));
                            dispatch(handleChangeInputUserAuthenticationgPage('mobile', response.data.mobile));

                            setBarcodeCollapsed(false);

                            setIsVisibleAddForm(true);
                            setAddFormCollapsed(true);

                            break;
                        default:
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
                    }
                    dispatch(handleChangeInputUserAuthenticationgPage('barcodeBtnDisable', false));
                }, () => {
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
                    dispatch(handleChangeInputUserAuthenticationgPage('barcodeBtnDisable', false));
                });
            }
            else
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'بارکد باید 4 رقم باشد!', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
    };



    const [isBarcodeBoxHeadingVisible, setIsBarcodeBoxHeadingVisible] = useState(false);
    const [isAddTransBoxHeadingVisible, setIsAddTransBoxHeadingVisible] = useState(false);


    return (


		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <Row className="content-header">
                </Row>
                <div className="content-body">



                
                    <Row className="content-header mb-1 display-hidden">
                        <Col md={6} xs={12} className="content-header-left mb-1">
                            <h2 className="content-header-title">
                                فرم ثبت  تراکنش
                            </h2>
                        </Col>
                    </Row>


                    <Row >
                        <Col xs={12} md={6} lg={4} >
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">
                                        اعتبار سنجی کاربر
                                    </h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsBarcodeBoxHeadingVisible(! isBarcodeBoxHeadingVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isBarcodeBoxHeadingVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse" id="btn-collapse-expand-box2"><i className={barcodeCollapsed ? "icon-minus4" : "icon-plus4"} onClick={handleBarcodeCollapsed}></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <Collapse in={barcodeCollapsed} className="card-body collapse in">
                                    <div className="card-block">
                                        <div className="form-body" style={{overflow: 'unset !important'}} >
                                            <Row >
                                                <Col xs={12} className="col-xs-12">
                                                    <p className="text-muted">
                                                        بارکد روی گوشی کاربر را وارد کنید
                                                    </p>
                                                    <input type="text" name="barcode" className="form-control" placeholder="xxxx"
                                                           id="input-barcode" style={{marginLeft: '15px'}}
                                                           value={barcode} onChange={handleNormalInput} />
                                                    <button type="submit" id="btn-check-barcode" className="btn btn-success w-100 mt-2" name="" value="" disabled={barcodeBtnDisable} onClick={handleSubmitFormBarcode} >تایید
                                                        <img src={AjaxLoader} width="24" id="ajax-loader-btn-check-barcode" className="ml-2" style={ !barcodeBtnDisable ? {display: 'none'} : null} />
                                                    </button>
                                                </Col>
                                            </Row>
                                                    
                                                
                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                        </Col>


                        
                    </Row>



                    <Row>
                        <div className="col-xs-12">

                            <div id="card-trans" className={`card ${isVisibleAddForm ? "show" : "hide"}`} style={{minHeight: 'unset !important', display: 'block'}} >
                                <div className="card-header">
                                    <h4 className="card-title">
                                        اطلاعات کاربر
                                    </h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsAddTransBoxHeadingVisible(! isAddTransBoxHeadingVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isAddTransBoxHeadingVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className={addFromCollapsed ? "icon-minus4" : "icon-plus4"} onClick={handleAddFormCollapsed}></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <Collapse in={addFromCollapsed} className="card-body collapse in">
                                    <div className="card-block">
                                        <div className="form-body" style={{overflow: 'unset !important'}} >

                                            <div className="row ">
                                                <div className="col-md-4">
                                                    <div className="card border-gray border-lighten-1">
                                                        <div className="p-1">
                                                            <p className="mb-0">
                                                                <small className="text-muted">نام کاربر</small>
                                                            </p>
                                                            <p className="mb-0" id="p-user-fullname">
                                                                {fullname}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card border-gray border-lighten-1">
                                                        <div className="p-1">
                                                            <p className="mb-0">
                                                                <small className="text-muted">کدملی</small>
                                                            </p>
                                                            <p className="mb-0" id="p-user-nationalcode">
                                                                {nationalCode}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card border-gray border-lighten-1">
                                                        <div className="p-1">
                                                            <p className="mb-0">
                                                                <small className="text-muted">نوع کاربر</small>
                                                            </p>
                                                            <p className="mb-0" id="p-user-nationalcode">
                                                                {orgTxt}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="card border-gray border-lighten-1">
                                                        <div className="p-1">
                                                            <p className="mb-0">
                                                                <small className="text-muted">موبایل</small>
                                                            </p>
                                                            <p className="mb-0" id="p-user-credit">
                                                                {mobile}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card border-gray border-lighten-1">
                                                        <div className="p-1">
                                                            <p className="mb-0">
                                                                <small className="text-muted">موجودی کیف پول</small>
                                                            </p>
                                                            <p className="mb-0" id="p-user-credit">
                                                                {normalCreditNumeric} ریال
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card border-gray border-lighten-1">
                                                        <div className="p-1">
                                                            <p className="mb-0">
                                                                <small className="text-muted">اعتبار سازمانی</small>
                                                            </p>
                                                            <p className="mb-0" id="p-user-credit">
                                                                {orgCreditNumeric} ریال
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                    </Row>




                </div>
            </div>
        </div>



    );
}

export default UserAuthentication;